<template>
    <div>
        <section v-if="form.productLine">
            <div class="container">
                <div class="text-title">Archived Downloads</div>

                <q-card>
                    <q-card-section :horizontal="screenSize.gt.sm" class="q-pa-none">
                        <q-card-section class="col-6" :class="{'q-pa-xl' : !screenSize.xs}">
                            <img :src="form.productLine.logo" class="img-logo q-my-md" :title="form.productLine.name" />
                            <div class="q-mb-sm">Please choose a product and version to download</div>
                            <div>
                                <q-select outlined dense class="q-mb-md"
                                          label="Product Type" stack-label
                                          autocomplete="off"
                                          @input="$router.push(`/archived/download/${form.productLine.name.toLowerCase()}`)"
                                          v-model="form.productLine" :options="productLines"
                                          option-label="name"
                                          hide-bottom-space />
                            </div>

                            <div v-if="showOems && oems.length > 1">
                                <q-select outlined dense class="q-mb-md"
                                          label="OEM Edition" stack-label
                                          autocomplete="off"
                                          @input="updateRoute"
                                          v-model="form.oem" :options="oems"
                                          option-label="name"
                                          hide-bottom-space />
                            </div>

                            <div v-if="downloadVersions && downloadVersions.length > 0">
                                <q-select outlined dense class="q-mb-md"
                                          label="Version" stack-label
                                          autocomplete="off"
                                          v-model="form.version" :options="downloadVersions"
                                          @input="getRevision"
                                          :option-label="(item) => item.version.replace(' - OEM Editions', '')"
                                          hide-bottom-space />
                            </div>

                            <div v-if="form.productLine.name !== 'PlumbingCAD'" class="q-my-md">
                                <div class="row items-center text-warning text-caption q-mb-xs">
                                    <q-icon name="mdi-alert" size="1.5em" class="q-mr-xs" /><span>You are downloading an outdated version!</span>
                                </div>
                                <div v-if="form.productLine.name !== 'PlumbingCAD'" class="text-caption text-grey-7">
                                    <p>A current version of the {{ form.productLine.name }} program is available and it is strongly recommended that you update to the newest version.</p>
                                    <p>The download of older versions made available here is provided on an "as is" basis only. These older versions may contain outdated data and calculations, and use of these versions is completely at your own risk.</p>
                                </div>
                                <q-btn outline color="primary" no-caps @click="latestLink" class="row items-center full-width">
                                    <q-icon name="mdi-update" size="1.5em" class="q-mr-xs" /><span>Click here for the latest version.</span>
                                </q-btn>
                            </div>
                        </q-card-section>

                        <q-separator :vertical="screenSize.gt.sm" inset class="q-mb-sm" />
                        <q-card-section v-if="form.version" class="col-6" :class="{'q-pa-xl' : !screenSize.xs}">
                            <download-form :download="form.version"
                                           :oem="form.oem"
                                           :class="{'q-my-md' : screenSize.gt.sm}" />
                        </q-card-section>
                        <q-card-section v-else class="col-6 q-px-xl q-pa-lg q-mb-md column justify-center">
                            <div class="text-center text-negative">
                                <q-icon name="mdi-download-off-outline" size="xl" />
                                <p>No archived downloads found for selected product and edition.</p>
                            </div>
                        </q-card-section>
                    </q-card-section>
                </q-card>
                <div class="q-mt-lg">
                    <revision-notes :revision="revision" />
                </div>
            </div>
        </section>
        <div v-if="pending">
            <q-inner-loading :showing="true">
                <div>
                    <q-spinner color="primary"
                               :thickness="2"
                               size="3em" />
                </div>
            </q-inner-loading>
        </div>
        <q-page-sticky position="bottom-right" :offset="[18, 18]">
            <q-btn fab icon="mdi-arrow-left" color="primary" @click="$router.push(`/download/${productLine}`)" />
        </q-page-sticky>
    </div>
</template>
<script>
    import revisionNotes from '@/components/RevisionNotes'
    import downloadForm from '@/components/DownloadForm'
    import { mapState } from 'vuex'
    import { productLines } from '@/plugins/productLines'

    export default {
        name: 'archived-downloads',
        components: {
            revisionNotes,
            downloadForm
        },
        props: {
            productLine: String,
        },
        data() {
            return {
                revision: null,
                allDownloads: [],
                productLines: Object.keys(productLines)?.map(key => { return productLines[key] })?.filter(pl => pl.name !== 'PlumbingCAD'),
                form: {
                    productLine: null,
                    version: null,
                    oem: null,
                }
            }
        },
        methods: {
            latestLink() {
                this.$router.push(`/download/${this.productLine}`)
            },
            getOems() {
                this.$store.dispatch('getOEMs').then(() => {
                    this.getDownloads()
                })

            },
            getDownloads() {
                this.allDownloads = []
                this.$store.dispatch('getDownloads').then(() => {
                    this.allDownloads = this.getDownloadsData?.filter(d => !d.latestVersion)
                    this.setupOem()
                })
            },
            getRevision() {
                if (this.form.version) {
                    this.revision = null
                    const payload = {
                        productCategoryId: this.form.version.productCategoryID,
                        version: this.form.version.versionText,
                    }
                    this.$store.dispatch('getRevision', payload).then(() => {
                        this.revision = this.getRevisionData
                    })
                }
                else this.revision = null
            },
            setupOem() {
                this.form.oem = null

                if (!this.getOemsData || !this.form.productLine) return

                if (this.$route.query.oem && this.oems && this.oems.length > 0) {
                    this.form.oem = this.oems?.find(o => o.id.toLowerCase() == this.$route.query.oem.toLowerCase())
                    return
                }

                if (!this.form.oem && this.oems && this.oems.length > 0) {
                    this.form.oem = this.oems[0]
                    return
                }

            },
            updateRoute() {
                let queryParams = {}
                if (this.form.oem)
                    queryParams.oem = this.form.oem?.id.toLowerCase()

                this.$router.replace({
                    path: this.$route.path,
                    query: queryParams,
                }).catch(err => { })
            },
            updateOem() {
                this.setupOem()
                this.updateRoute()
            },
            updateProductLine() {
                if (this.productLine)
                    this.form.productLine = this.productLines?.find(pl => pl.name.toLowerCase() == this.productLine.toLowerCase())
                if (!this.form.productLine) this.$router.push('/archived/download/loopcad')

                this.updateOem()
            },
        },
        computed: {
            ...mapState([
                'getOemsPending',
                'getOemsData',
                'getDownloadsPending',
                'getDownloadsData',
                'getRevisionPending',
                'getRevisionData',
            ]),
            pending() {
                return this.getOemsPending || this.getDownloadsPending || this.getRevisionPending
            },
            screenSize() {
                return this.$q.screen
            },
            showOems() {
                if (this.form.productLine.name.toLowerCase() === 'loopcad')
                    return true
                return false
            },
            oems() {
                if (this.getOemsData)
                    return this.getOemsData?.filter(o => o.productCategoryID == this.form.productLine.name && o.visible == true && this.allDownloads?.some(d => d.oemId == o.id))
                return []
            },
            downloadVersions() {
                if (this.form.productLine && this.allDownloads.length > 0) {
                    let downloads
                    if (this.form.oem)
                        downloads = this.allDownloads?.filter(d => d.productCategoryID == this.form.productLine.name && d.oemId == this.form.oem.id && !d.latestVersion)
                    else
                        downloads = this.allDownloads?.filter(d => d.productCategoryID == this.form.productLine.name && !d.latestVersion)

                    return downloads.sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))
                }
                return null
            },

        },
        created() {
            this.getOems()
            this.updateProductLine()
        },
        watch: {
            'form.version'(newVal) {
                this.getRevision()
            },
            downloadVersions(newVal) {
                if (newVal && newVal.length > 0) {
                    this.form.version = newVal[0]
                }
                else this.form.version = null
            },
            productLine(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.updateProductLine()
                }
            },
            '$route.query.oem'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.setupOem()
                }
            }
        },
    }
</script>
<style scoped>
    .img-logo {
        max-width: 100%;
        max-height: 55px;
        width: unset;
    }

    .img-oem-logo {
        max-width: 275px;
        max-height: 100%;
        height: unset;
    }
</style>
